import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";

export type ExactOnlineFailureID = number;

export enum EXACT_ACTIONS {
  ExactActionGetItem = 1,
  ExactActionGetItemExtraField = 2,
  ExactActionPostAccount = 3,
  ExactActionPutAccount = 4,
  ExactActionPostContact = 5,
  ExactActionPutContact = 6,
  ExactActionGetContact = 7,
  ExactActionPostSalesInvoice = 8,
  ExactActionGetDocument = 9,
  ExactActionGetInvoicePdf = 10,
  ExactActionDeleteAccount = 11,
  ExactActionGetAccount = 12,
  ExactActionGetSalesInvoice = 13
}

export interface ExactOnlineFailure {
  created_on: string;
  id: ExactOnlineFailureID;
  exact_action: EXACT_ACTIONS; // The action of the request
  url: string; // Called endpoint of the request that failed
  request_body?: string; // RequestBody of the request that failed
  status_code?: number; // Retrieved status code for the request that failed
  errormessage?: string; // Returned error message for the request that failed
  dealer_location_id?: DealerLocationID; // Identifier of the location that the failure is for
  dealer_id?: DealerID; // Identifier of the dealer that the failure is for
  dealer_name?: string;
  location_name?: string;
}
